import { render, staticRenderFns } from "./guwen.vue?vue&type=template&id=9b41b672&scoped=true"
import script from "./guwen.vue?vue&type=script&lang=js"
export * from "./guwen.vue?vue&type=script&lang=js"
import style0 from "./guwen.vue?vue&type=style&index=0&id=9b41b672&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b41b672",
  null
  
)

export default component.exports